<template>
  <div style="box-sizing: border-box; padding: 10px 20px 0; min-width: 1080px">
    <div class="section-right-content-box">
      <div class="router-title">自动化打标</div>
      <div class="screen-box" style="text-align: left">
        <div class="line">
          <div>
            <div class="item">
              <div class="item-name" style="margin-right: -12px">标签搜索:</div>
              <el-input
                class="long-input"
                v-model="valueLabel"
                maxlength="15"
                size="small"
                placeholder="请输入..."
                style="margin-right: -15px"
              >
                <span
                  style="display: inline-block; line-height: 32px; color: #666"
                  class="input-text"
                  slot="suffix"
                >
                  <!-- {{searchForm.label.length}} -->
                </span>
              </el-input>
            </div>
            <el-button
              icon="el-icon-search"
              class="status_btn1"
              v-zoom="{ from: pageName, name: '查询' }"
              @click="searchContent"
              >查询</el-button
            >
            <el-button class="status_btn2" @click="resetBtn1">重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 表格数据部分 -->
    <div class="table-data-box">
      <div class="button-box">
        <div class="float-left-button">
          <div
            class="button"
            v-zoom="{ from: pageName, name: '添加规则' }"
            @click="addRule"
          >
            <img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin-top: 8px;
                margin-right: 4px;
              "
            />
            <span class="button-title">添加规则</span>
          </div>
        </div>
      </div>
      <div class="table-box">
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          tooltip-effect="light"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; border: 1px solid #eee"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <div>
              <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="labelName" label="标签名称"></el-table-column>
          <el-table-column
            prop="groupName"
            label="打标签分组"
          ></el-table-column>
          <el-table-column prop="crtime" label="创建时间"></el-table-column>
          <el-table-column prop="updateTime" label="修改时间"></el-table-column>
          <el-table-column label="开启自动打标">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isOpen"
                active-color="#49C568"
                inactive-color="#B1B6BD"
                @change="updateState(scope.row.id, scope.row.isOpen)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="text"
                  class="operation"
                  v-zoom="{ from: pageName, name: '修改' }"
                  @click="modData(scope.row, scope.index)"
                  >修改</el-button
                >
                <el-button
                  type="text"
                  class="operation"
                  @click="deleteData(scope.row.id)"
                  v-zoom="{ from: pageName, name: '删除' }"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="margin-top: 20px; text-align: right"
          @size-change="handleSizeChange"
          @current-change="handsizeleCurrentChange"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="searchForm.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalList"
          :current-page="searchForm.current"
        ></el-pagination>
      </div>
    </div>

    <!-- 创建修改弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :title="mod === 'add' ? '  ' : '修改打标规则'"
    >
      <div>
        <el-tabs v-model="active" @tab-click="handleTab">
          <el-tab-pane label="会员分组" name="1">
            <div>
              <div>
                <el-button
                  class="zidingyi_button1"
                  style="width: 90px; margin: 0 0 10px 0"
                  @click="goToGroup"
                  >创建分组</el-button
                >
                <div
                  style="
                    height: 32px;
                    line-height: 32px;
                    display: inline-block;
                    margin-left: 20px;
                  "
                >
                  已选标签数:
                  <span :style="{ color: globalBG }">{{
                    SelLabel.length
                  }}</span>
                </div>
              </div>
              <!-- 分组 -->
              <div class="labelCnt">
                <div class="groupList">
                  <div
                    v-for="(item, index) in groupingList"
                    class="groupItem"
                    :key="index"
                  >
                    <el-checkbox-group v-model="checkList">
                      <el-checkbox :label="item.id">{{
                        item.groupName
                      }}</el-checkbox>
                    </el-checkbox-group>
                    <span>{{ item.buyerNum }}</span>
                  </div>
                </div>

                <!-- 标签 -->
                <div class="labelList">
                  <el-checkbox-group v-model="SelLabel">
                    <el-checkbox
                      v-for="(item, index) in MemberLabelList"
                      :label="item.id"
                      :key="index"
                    >
                      <span>{{ item.labelName }}</span>
                      <i class="el-icon-check"></i>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="zidingyi_button2" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button class="zidingyi_button3" @click="sureFn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import {
  getBuyerByLabelName,
  deleteBuyerById,
  modificationImplementationRule,
  insertImplementation,
  modificationImplementationSwith,
} from "@/api/autoMarkConfigController";

import { getShopBuyerGroup } from "@/api/shopBuyerGroup";
import { getMemberLabel } from "@/api/buyerLabelController";
import { Message } from "element-ui";

export default {
  name: "share_polite",
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  data() {
    return {
      valueLabel: "",
      //查询数据
      searchForm: {
        size: 10,
        current: 1,
        // labelName:"", //标签名字
        // groupName:"", //打标签分组
        // crtime:"",  //创建时间
        // updateTime:"",  //修改时间
        // labelId:"",
      },
      searchFormss: {
        pageSize: 500,
        page: 0,
        size: 500,
      },
      mod: "add",
      val: "",
      id: "",
      ids: "",
      // isOpen: "",
      tableLoading: true,
      tableData: [],
      totalList: 0,
      dialogVisible: false,
      active: "1",
      SelLabel: [],
      groupInfo: [],
      labelInfo: [],
      groupingList: [],
      MemberLabelList: [],
      checkList: [], // 选中的分组
      contentAllId: {},
      pageName: "客户管理-自动化打标签",
      sureFnlist: {
        groupId: "",
        labelId: "",
      },
    };
  },
  mounted() {
    this.searchData();
    this.getgrouping();
    this.getgetMemberLabel();
  },
  methods: {
    //表格数据查询
    searchData() {
      getBuyerByLabelName(this.searchForm).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data.records;
        this.totalList = res.data.total;
      });
    },
    //查询
    searchContent() {
      this.searchForm.current = 1;
      this.searchForm.labelName = this.valueLabel;
      this.searchData();
    },
    //点击自动打标
    updateState(id, isOpen) {
      let dto = { id, isOpen: isOpen };
      modificationImplementationSwith(dto).then((res) => {
        if (res && res.code == 1) {
          this.searchData();
          this.$message.success("操作成功");
        }
      });
    },
    //修改传参
    //删除
    deleteData(id) {
      // this.ids = id;
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          deleteBuyerById(id).then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.searchData();
            } else {
              this.$message.error("开启状态下不能删除！");
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    addRule() {
      //添加规则
      this.mod = "add";
      this.dialogVisible = true;
      this.checkList = [];
      this.SelLabel = [];
    },

    handleSelectionChange() {
      //表格选择
    },
    //重置
    resetBtn1() {
      this.valueLabel = "";
    },
    handleSizeChange(val) {
      this.searchForm.current = 1;
      this.searchForm.size = val;
      this.searchData();
    },
    handsizeleCurrentChange(val) {
      this.searchForm.current = val;
      this.searchData();
    },
    //修改
    modData(row) {
      console.log(row);
      this.mod = "edit";
      this.ids = row.id;
      this.dialogVisible = true;
      let groupIdArr = row.groupId.split(",");
      let labelIdArr = row.labelId.split(",");
      // console.log(labelIdArr);
      this.checkList = groupIdArr.map((i) => Number(i));
      this.SelLabel = labelIdArr.map((i) => Number(i));

      console.log(this.SelLabel, 222);
      let arr = this.SelLabel;
      arr = arr.filter((item) => {
        return item != 0;
      });
      console.log(arr, 1111);
      this.SelLabel = arr;
      // this.SelLabel = labelIdArr.forEach((i) => Number(i));
      // console.log(this.SelLabel, this.SelLabel.length);
    },

    // 确认按钮
    sureFn() {
      // let SelLabelArr = [];
      // this.SelLabel.forEach((item, index) => {
      //   SelLabelArr = SelLabelArr.concat(item.id);
      // });
      let contentId = {
        groupId: this.checkList.toString(),
        // labelId: "," + this.SelLabel.toString() + ",",
        labelId: this.SelLabel.toString(),

        // isOpen: false,
      };

      // this.sureFnlist.id = this.ids;
      if (this.mod == "add") {
        insertImplementation(contentId).then((res) => {
          // console.log(res);
          if (res.code === 1) {
            this.dialogVisible = false;
            this.searchData();
            // this.checkList = [];
            // this.SelLabel = [];
            console.log(this.SelLabel, this.SelLabel.length);
            this.$message.success("创建成功");
          } else {
            this.$message.error(res.message);
          }
        });
      } else if (this.mod == "edit") {
        let contentAllId = {
          groupId: this.checkList.toString(),
          labelId: "," + this.SelLabel.toString() + ",",
          id: this.ids,
        };
        modificationImplementationRule(contentAllId)
          .then((res) => {
            if (res.code === 1) {
              this.dialogVisible = false;
              this.searchData();
              this.$message.success("修改成功");
            } else {
              this.$message.error("分组和标签不能为空");
            }
          })
          .catch(() => {
            this.$message.error("修改失败");
          });
      }
    },

    handleTab() {},

    goToGroup() {
      //创建分组
      this.$router.push("/manage/manage/focus_merchandise");
    },

    //获取会员分组
    getgrouping() {
      getShopBuyerGroup(this.searchFormss).then((res) => {
        this.groupingList = res.data.records;
      });
    },
    // 获取标签
    getgetMemberLabel() {
      getMemberLabel().then((res) => {
        this.MemberLabelList = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.zidingyi_button1 {
  width: 98px;
  height: 32px;
  color: #ffffff;
  border: 1px solid #fe4d45;
  border-radius: 3px;
  background-color: #fe4d45;
  &:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }
  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
.zidingyi_button2 {
  width: 98px;
  height: 32px;
  color: #999999;
  border-radius: 3px;
  border: 1px solid #cccccc;
  background-color: #fff;
  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
.zidingyi_button3 {
  width: 98px;
  height: 32px;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  background-color: #fff;
  &:hover {
    color: #fff;
    border: 1px solid #fff;
    background-color: #fe4d45;
  }
  &:active {
    color: #fff;
    border: 1px solid #fff;
    background-color: #fe4d45;
  }
}
.labelCnt {
  min-height: 420px;
  .groupList {
    margin-top: 10px;
    background-color: #f5f5f5;
    height: 400px;
    overflow: auto;
    overflow-x: hidden;
    float: left;
    width: 30%;
    padding: 20px 5px 0;
    .groupItem {
      height: 32px;
      line-height: 32px;
      overflow: hidden;
      padding: 0 5px;
      span {
        float: right;
      }
    }
  }
  .labelList {
    margin-top: 10px;
    float: left;
    width: 70%;
    padding: 20px 10px 0px;
    /deep/.el-checkbox {
      height: 32px;
      margin-bottom: 10px;
      line-height: 32px;
      border: 1px solid #d2d2d2;
      border-radius: 2px;
      .el-checkbox__input {
        display: none;
      }
      .el-checkbox__label {
        padding: 0;
        vertical-align: top;
        margin-bottom: 10px;
        span {
          height: 30px;
          line-height: 30px;
          display: inline-block;
          padding: 0 10px;
          background-color: #d2d2d2;
          color: #fff;
          padding-bottom: 10px;
        }
        i {
          width: 30px;
          text-align: center;
          /* color: #fff; */
          font-size: 20px;
        }
      }
    }
  }
  &::after {
    content: "";
    clear: both;
    overflow: hidden;
    display: block;
  }
}
.section-right-content-box {
  background-color: #fff;
  /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); */
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  // padding: 16px 16px 27px 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  .router-title {
    padding: 5px 0 5px 30px;
    font-size: 16px;
    color: #2e3458;
    margin-bottom: 37px;
    font-weight: bold;
    line-height: 42px;
    border-bottom: 1px solid #f0f0f0;
  }
  .screen-box {
    margin-top: -10px;
    padding: 0 0 27px 30px;
    .line {
      color: #666;
      .status_btn1 {
        width: 98px;
        height: 32px;
        font-size: 14px;
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff;
      }
      .status_btn1:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
      .status_btn2 {
        width: 98px;
        font-size: 14px;
        height: 32px;
        color: #666666;
        border: 1px solid #dddddd;
        background-color: #fff;
      }
      .status_btn2:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      .item {
        display: inline-block;
        vertical-align: middle;
        margin-right: 3%;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .item-name {
          display: inline-block;
          vertical-align: middle;
          width: 80px;
          font-size: 14px;
          color: #333;
        }
        .to-text {
          display: inline-block;
          vertical-align: middle;
          margin: 0 7px;
        }
        .long-input {
          display: inline-block;
          vertical-align: middle;
          width: 220px;
        }
        .short-input {
          display: inline-block;
          vertical-align: middle;
          width: 86px;
        }
        .picker {
          display: inline-block;
          vertical-align: middle;
          width: 200px;
        }
        .checked-box {
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
  }
}
.table-data-box {
  margin: 20px 0;
  background-color: #fff;
  /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); */
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 26px 30px 30px 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  .operation {
    cursor: pointer;
    color: #7f85e9;
    width: 20px;
    margin-left: 20px;
    &:hover {
      color: #fe4d45;
    }
  }
  .button-box {
    margin-bottom: 20px;
    .float-left-button {
      .button {
        background-color: #fe4d45;
        color: #fff;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        padding: 0 16px;
        // border: 1px solid rgba(221, 221, 221, 1);
        font-size: 14px;
        min-width: 90px;
        text-align: center;
        height: 32px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        margin-right: 15px;
        cursor: pointer;
        .font_family {
          width: 12px;
          height: 12px;
          vertical-align: middle;
          margin-right: 4px;
        }
        .button-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        .button-title {
          display: inline-block;
          line-height: 32px;
          vertical-align: middle;
        }
        &:hover {
          opacity: 0.9;
          background-color: #fe4d45;
        }
      }
    }
  }
}
.dialog-footer {
  justify-content: center;
}
</style>
